<div [formGroup]="form"
     cdkScrollable
     class="filter"
     mat-dialog-content>
  <div class="filter-content">
    <app-table-filter-menu-header [title]="config.title"></app-table-filter-menu-header>

    <!--    accordion animation is disabled because of jump content dialog close https://github.com/angular/components/issues/11765-->
    <mat-accordion [@.disabled]="true" class="accordion" multi>
      <mat-expansion-panel class="expansion-panel" *ngFor="let group of config.filterGroups"
                           [attr.data-test-id]="group.testId"
                           [expanded]="group.expandedByDefault">
        <mat-expansion-panel-header>

          <mat-panel-title class="group-title">
            <ng-container *ngIf="group.icon">
              <mat-icon *ngIf="!group.icon.isCustom; else customIcon"
                        class="material-icons_grey group-title-icon">{{group.icon.name}}</mat-icon>
              <ng-template #customIcon>
                <img class="group-title-icon" [alt]="group.icon.name"
                     [src]="'/assets/images/' + group.icon.name + '.svg'">
              </ng-template>
            </ng-container>
            {{ group.title }}
            <span class="group-title-counter"
                  *ngIf="changedControls[group.controlName]">({{ changedControls[group.controlName] }})</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <div [formGroupName]="group.controlName" class="mt-6">
            <ng-container *ngFor="let filter of group.filters"
                          [ngSwitch]="filter.type">
              <div *ngSwitchCase="TableFilterType.Input" class="mt-6">
                <app-input-filter *ngIf="displayFilter(group.controlName, filter)"
                                  [config]="filter"
                                  [controlName]="filter.controlName"
                                  [form]="getGroup(group.controlName)"></app-input-filter>
              </div>
              <div *ngSwitchCase="TableFilterType.Autocomplete" class="mt-6" [hidden]="!displayFilter(group.controlName, filter)">
                <app-autocomplete-filter [config]="filter"
                                         [controlName]="filter.controlName"
                                         [form]="getGroup(group.controlName)"></app-autocomplete-filter>
              </div>
              <div *ngSwitchCase="TableFilterType.PhoneNumber" class="mt-6">
                <app-phone-number-filter *ngIf="displayFilter(group.controlName, filter)"
                                         [config]="filter"
                                         [controlName]="filter.controlName"
                                         [form]="getGroup(group.controlName)"></app-phone-number-filter>
              </div>
              <div *ngSwitchCase="TableFilterType.Radio" class="mt-6">
                <app-radio-filter *ngIf="displayFilter(group.controlName, filter)"
                                  [config]="filter"
                                  [controlName]="filter.controlName"
                                  [form]="getGroup(group.controlName)"></app-radio-filter>
              </div>
              <div *ngSwitchCase="TableFilterType.Checkbox">
                <app-checkbox-filter *ngIf="displayFilter(group.controlName, filter)"
                                     [config]="filter"
                                     [controlName]="filter.controlName"
                                     [form]="getGroup(group.controlName)"></app-checkbox-filter>
              </div>
              <div *ngSwitchCase="TableFilterType.Date" class="mt-6">
                <app-date-filter *ngIf="displayFilter(group.controlName, filter)"
                                 [config]="filter"
                                 [controlName]="filter.controlName"
                                 [form]="getGroup(group.controlName)"></app-date-filter>
              </div>
              <div *ngSwitchCase="TableFilterType.NumberInput">
                <app-number-input-filter *ngIf="displayFilter(group.controlName, filter)" [config]="filter"
                                         [controlName]="filter.controlName"
                                         [form]="getGroup(group.controlName)"></app-number-input-filter>
              </div>
              <div *ngSwitchCase="TableFilterType.DoubleDate" class="mt-6">
                <app-double-date-filter *ngIf="displayFilter(group.controlName, filter)"
                                        [config]="filter"
                                        [form]="getSubGroup(group.controlName, filter.controlName)"
                ></app-double-date-filter>
              </div>
              <div *ngSwitchCase="TableFilterType.DoubleNumberInput" class="mt-6">
                <app-double-number-input-filter
                  *ngIf="displayFilter(group.controlName, filter)"
                  [config]="filter"
                  [form]="getSubGroup(group.controlName, filter.controlName)"></app-double-number-input-filter>
              </div>
            </ng-container>

            <button (click)="clearGroup(group.controlName)"
                    *ngIf="group.hasClearBtn && changedControls[group.controlName]"
                    [attr.data-test-id]="'clear-group-' + group.controlName"
                    class="clear-group-button"
                    color="primary"
                    mat-button>
              Очистити
            </button>
          </div>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <app-table-filter-menu-footer (filtersApplied)="applyFilterForm()"
                                (filtersCleared)="clearFilters()"
                                [config]="config"
                                [isDirty]="isDirty"
                                [isFiltered]="filtered$ | async"
                                [isLoading]="isLoading"
                                [counter]="totalCounter"
                                [isValid]="form.valid"></app-table-filter-menu-footer>
</div>
